import { useMemo } from 'react';
import { OrderStatusEnum } from 'types/graphql';
import { getShiftBiddingStatus } from 'utils/shiftStatus';

interface UseAutoExtendBidParams {
  biddable: boolean;
  autoRebid: boolean;
  sentToAgencies: boolean;
  bidders: unknown[];
  status: OrderStatusEnum;
  biddingTimeEndsAt?: string;
}

export const useAutoExtendBid = ({
  biddable,
  autoRebid,
  sentToAgencies,
  bidders,
  status,
  biddingTimeEndsAt,
}: UseAutoExtendBidParams) => {
  const isAutoBidAllowed = useMemo(() => {
    const biddingStatus = getShiftBiddingStatus({
      status,
      biddable,
      biddingTimeEndsAt,
      bidders,
    });

    return (
      biddable &&
      !autoRebid &&
      !sentToAgencies &&
      (!Array.isArray(bidders) || bidders.length === 0) &&
      (biddingStatus === 'NO_BIDS' || biddingStatus === 'BIDDING')
    );
  }, [biddable, autoRebid, sentToAgencies, bidders, status, biddingTimeEndsAt]);

  return {
    isAutoBidAllowed,
    shouldDisableAutoExtendBidToggle: !isAutoBidAllowed,
  };
};
